// extracted by mini-css-extract-plugin
export var modal = "_tg-0";
export var table = "_tg-1";